import apiClient from '../index';

export const kamatiApi = {
  // Get all committee members
  getCommitteeMembers: (page = 1, search = '') => apiClient.get('/kamati/list-members', {
    params: { page, ...(search && { search }) }
  }),
  
  // Get all kamati tasks/roles
  getKamatiTasks: () => apiClient.get('/kamati'),

  // Get kamati task/role by ID
  getKamatiTask: (id) => apiClient.get(`/kamati/${id}`),

  // Create kamati task/role
  createKamatiTask: (data) => apiClient.post('/kamati', data),
  
  // Add new committee member
  addCommitteeMember: (data) => apiClient.post('/kamati/add-member', data),
  
  // Update kamati task/role
  updateKamatiTask: (id, data) => apiClient.put(`/kamati/${id}`, data),
  
  // Delete kamati task/role
  deleteKamatiTask: (id) => apiClient.delete(`/kamati/${id}`),

  // Update committee member
  updateCommitteeMember: (id, data) => apiClient.put(`/kamati/${id}`, data),

  // Delete committee member
  deleteCommitteeMember: (id) => apiClient.delete(`/kamati/${id}`),
  
  // Get member by token (for activation)
  getMemberByToken: (token) => apiClient.get(`/kamati/verify-new-member/${token}`),
  
  // Activate member by token
  activateMember: (token, data) => apiClient.post(`/kamati/verify-new-member/${token}`, data),
};

export default kamatiApi;